<div class="sh-panel">
  @if (securityGroupsLoading$ | async) {
    <sh-notification [message]="'ui.loading' | translate"></sh-notification>
  }

  @if ((readonlySecurityGroups$ | async) || (editableSeriesSecurityGroups$ | async)) {
    <div class="sh-content-columns">
      <section class="sh-content-columns__column">
        <h6>{{ "security.label" | translate }}</h6>
        <sh-form-select
          [id]="'security-groups-select'"
          [label]="'security.set-security-groups' | translate"
          [control]="securityGroupsControl"
          [options]="allSecurityGroupsSelectOptions$ | async"
          >
        </sh-form-select>
      </section>
    </div>
    <div class="sh-content-columns">
      <section class="sh-content-columns__column">
        <h6>{{ "security.inherited-security-groups" | translate }}</h6>
        @if (readonlySecurityGroups$ | async; as readonlySecurityGroups) {
          <ul class="digihaven-unstyled-list">
            @for (securityGroup of readonlySecurityGroups; track securityGroup) {
              <li>{{ securityGroup.Name }}</li>
            }
            @if (readonlySecurityGroups.length === 0) {
              <li>
                <em>{{ "security.no-security-groups" | translate }}</em>
              </li>
            }
          </ul>
        }
      </section>
    </div>
    <div class="sh-content-columns">
      <section class="sh-content-columns__column">
        <h6>{{ "security.current-security-groups" | translate }}</h6>
        @if (selectedSecurityGroups$ | async; as selectedSecurityGroups) {
          <ul class="digihaven-unstyled-list">
            @for (securityGroup of selectedSecurityGroups; track securityGroup) {
              <li class="digihaven-cross-value" (click)="removeSecurityGroup(securityGroup)">
                {{ securityGroup.label }} <svg class="digihaven-delete" sh-icon [name]="'delete'" [size]="'small'"></svg>
              </li>
            }
            @if (selectedSecurityGroups.length === 0) {
              <li>
                <em>{{ "security.no-security-groups" | translate }}</em>
              </li>
            }
          </ul>
        }
      </section>
    </div>
  }
</div>
